<template>
  <div class="question row align-items-center">
    <div class="row mt-4 px-0 align-items-center justify-content-start">
      <div class="col-lg-5 col-md-12 col-sm-12 px-0 justify-content-start">
        <h3 class="title-service text-left font-32 mb-0">{{ $t("question_component.title") }}</h3>
        <p class="text-left">{{ $t("question_component.description") }}</p>

        <div class="text-left">
          <RouterLink to="/faq" class="btn text-white foire-questions my-3">
            {{ $t("question_component.links.faq") }}
          </RouterLink>
        </div>
      </div>
      <div class="col-lg-1 col-md-1 col-sm-12"></div>
      <div class="col-lg-6 col-md-12 col-sm-12 px-0 my-3">
        <div class="accordion">
          <template v-for="(faq, index) in faqs" :key="index">
            <details>
              <summary>{{ faq.question }}</summary>
              <div class="response-content" @click="handleResponseClick" v-html="faq.reponse"></div>
            </details>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { useFaqsStore } from "@/stores/faqStore";
  import { useRegisterStore } from "@/stores/register";
  export default {
    name: "QuestionList",
    data() {
      return {
        faqStore: null,
        faqs: [],
      };
    },
    created() {
      this.registerStore = useRegisterStore();
      const role = this.registerStore.user?.role;
      const isClient = role === "client";
      this.faqStore = useFaqsStore();
      this.faqStore.fetchFaqsFooter(isClient);
      this.faqs = this.faqStore.faqsFooter.slice().sort((a, b) => a.position - b.position);
    },
    methods: {
      handleResponseClick() {
        this.$router.push("/faq");
      },
    },
  };
</script>

<style scoped>
  .question {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 20px;
    margin-top: 5px;
    justify-content: center;

    .content > div {
      text-align: left;
    }

    .content > div label {
      color: #1e347d;
      font-size: 35px;
      font-weight: 900;
      line-height: 55px;
      text-align: left;
    }
  }

  @media (max-width: 640px) {
    .content > div label {
      font-size: 30px !important;
    }
  }

  @media (max-width: 559px) {
    .content > div label {
      font-size: 24px !important;
    }
  }

  /* Responsive styles */
  @media (max-width: 992px) {
    .question {
      gap: 10px;
      padding-left: 8px;
      padding-right: 8px;
    }
    .title-service {
      font-size: 22px !important;
      line-height: 32px;
      margin-bottom: 10px;
    }
    .accordion {
      gap: 6px;
    }
    .foire-questions {
      font-size: 13px;
      padding: 8px 16px;
    }
  }

  @media (max-width: 768px) {
    .question {
      gap: 6px;
      padding-left: 4px;
      padding-right: 4px;
    }
    .title-service {
      font-size: 20px !important;
      line-height: 26px;
      margin-bottom: 6px;
    }
    .accordion {
      gap: 4px;
    }
    .foire-questions {
      font-size: 12px !important;
      padding: 6px 10px;
    }
    .question .row {
      flex-direction: column !important;
      align-items: stretch !important;
    }
    .col-lg-5,
    .col-lg-1,
    .col-lg-6,
    .col-md-12,
    .col-sm-12 {
      max-width: 100% !important;
      flex: 0 0 100% !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
    .title-service,
    .question p {
      text-align: left !important;
    }
    .accordion {
      margin-top: 12px;
    }
  }

  @media (max-width: 480px) {
    .title-service {
      font-size: 15px !important;
      line-height: 20px;
    }
    .accordion {
      gap: 2px;
    }
    .foire-questions {
      font-size: 11px;
      padding: 4px 6px;
    }
    summary {
      font-size: 13px;
    }
    .response-content {
      font-size: 12px;
    }
  }

  .foire-questions {
    background-color: #ec621a !important;
    border-radius: 76px;
    font-size: 15px;
    text-align: center;
  }

  .accordion {
    display: flex;
    flex-direction: column;
    gap: 8px;
    /* Espacement entre les éléments */
  }

  details {
    background: white;
    border-radius: 10px;
    border: 3px solid #d9dbe2;
    padding: 15px;
    margin-bottom: 8px;
  }

  summary {
    font-size: 16px;
    cursor: pointer;
    outline: none;
    background: white;
    color: #1e347d;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 500;
    transition: 0.3s;
    text-align: left;
  }

  summary::after {
    font-family: "themify";
    content: "\e64b";
    /* Flèche simple vers le bas */
    font-size: 14px;
    color: #ec621a;
    /* Flèche en orange */
    transition: linear 0.3s;
  }

  details[open] summary::after {
    content: "\e648";
  }

  details[open] summary {
    color: #ec621a;
  }

  details p {
    padding-top: 15px;
    margin: 0;
    background: white;
    color: #333;
  }

  .title-question {
    color: #1e347d;
    font-weight: 900;
    line-height: 55px;
    font-size: 38px;
    font-style: normal;
    justify-content: center;
  }

  .response-content {
    cursor: pointer;
  }
</style>
